// import { IState } from "@/interfaces/IState";
import { IQuiz } from "@/interfaces/quiz/IQuiz";
import axios from 'axios';

const evaluationInstance = axios.create({
    baseURL: process.env.VUE_APP_ROMA_EVALUATION_URL,
    withCredentials: false,
});

export const quiz = {
    state: {
        quantityQuestions: 0,
        questions: [],
        quizes: [],
        quiz: {},
        questionAndAnswers: [],
        questionsAnswered: [],
        idMedicionAsignada: 0,
        medicionTO: {},
        categories: [],
        idInstitucion: 0,
        information: {},
        answeredSurveys: [],
        notFound: false,
        urlPDF: null
    },
    mutations: {
        SET_QUESTIONS(state: IQuiz, payload: any) {
            state.questions = payload;
        },
        SET_QUESTIONS_ANSWERED(state: IQuiz, payload: any) {
            state.questionsAnswered = payload;
        },
        SET_QUESTIONS_AND_ANSWERS(state: IQuiz, payload: any) {
            state.questionAndAnswers = payload;
        },
        SET_QUANTITY_QUESTIONS(state: IQuiz, payload: any) {
            state.quantityQuestions = payload;
        },
        SET_QUIZES(state: IQuiz, payload: any) {
            state.quizes = payload;
        },
        SET_QUIZ(state: IQuiz, payload: any) {
            state.quiz = payload;
        },
        SAVE_QUIZ(state: IQuiz, payload: any) {
            state.quiz = payload;
        },
        SET_CATEGORIES(state: IQuiz, payload: any) {
            state.categories = payload;
        },
        SET_INFORMATION(state: IQuiz, payload: any) {
            state.information = payload;
        },
        SET_ANSWERED_SURVEYS(state: IQuiz, payload: any) {
            // let array = [];
            // array = state.answeredSurveys;
            // array.push(payload.surveys)
            state.answeredSurveys = payload;
        },
        NOT_FOUND(state: IQuiz, payload: any) {
            state.notFound = payload;
        },
        SET_ID_INSTITUTION(state: IQuiz, payload: any) {
            state.institutionId = payload;
        },
        SET_URL_PDF(state: IQuiz, payload: any) {
            state.urlPDF = payload;
        }
    },
    actions: {
        setQuestionAndAnswers(context: any, payload: any) {
            context.commit("SET_QUESTIONS_AND_ANSWERS", payload);
        },
        setQuestionsAnswered(context: any, payload: any) {
            context.commit("SET_QUESTIONS_ANSWERED", payload);
        },
        setQuantityQuestions(context: any, payload: any) {
            context.commit("SET_QUANTITY_QUESTIONS", payload);
        },
        async searchQuiz(context: any, payload: any) {
            return await axios.get(`${axios.defaults.baseURL}/roma-entrevista/encuesta/${payload}`)
                .then(response => {
                    if (response !== null && response.status === 200) {
                        const arrayPoll: any = [];
                        arrayPoll.push(response.data)
                        context.commit("SET_POLLS", { polls: arrayPoll })
                        return response;
                    } else {
                        return null;
                    }

                })
                .catch(error => {
                    console.info(error)
                    return 400;
                });
        },
        async setInformation(context: any, payload: any) {
            context.commit("SET_ID_INSTITUTION", payload.institutionId);
            return await axios.get(`${axios.defaults.baseURL}/roma-entrevista/institution/${payload.idInstitucion}`)
                .then(response => {
                    const infoGeneral = {
                        identificationCode: response.data.identificationCode,
                        implementer: response.data.implementer,
                        institutionId: response.data.institutionId,
                        name: response.data.name,
                        school: true,
                        timeZone: response.data.timeZone,
                        yearSelected: response.data.yearSelected,
                    };
                    context.commit("SET_INFORMATION", { information: infoGeneral });
                    context.commit("SET_CATEGORIES", { categories: response.data.categories });
                    context.commit("SET_ID_INSTITUTION", { idInstitucion: response.data.institutionId });
                    return response;
                })
                .catch(error => {
                    console.info(error.message)
                });
        },
        setQuiz(context: any, payload: any) {
            context.commit("SET_QUIZ", payload)
        },
        setQuestion(context: any, payload: any) {
            context.commit('SET_QUESTIONS', payload)
        },
        async saveQuiz(context: any, payload: any) {
            console.log(payload)
            
            return await axios.post(`${evaluationInstance.defaults.baseURL}answersRegister`, payload)
                .then(res => {
                    context.commit('SAVE_QUIZ', res.data);
                    context.commit('SET_QUESTIONS_ANSWERED', []);
                    context.commit('SET_QUESTIONS', []);
                    context.commit('SET_QUESTIONS_AND_ANSWERS', []);
                    console.log(payload.answers.idMedicionAsignada)
                    context.commit('SET_ANSWERED_SURVEYS', { surveys: payload.answers.idMedicionAsignada })
                    context.commit('SET_QUIZ', {});
                    // return res;
                })
                .catch(error => {
                    console.error(error)
                });
        },
        setNotFound(context: any, payload: any) {
            context.commit("NOT_FOUND", payload);
        },
        async setUrlPDF(context: any, payload: any) {
            console.log(payload)
            return await axios.get(`https://dev.romaevalua.cl/pdf/${payload.idMedicion}`)
                .then((data) => {
                    console.log(data)
                    return data;
                })
                .catch((err) => {
                    console.error(err)
                })
        },
        reset(context: any) {
            context.commit("SET_QUESTIONS_ANSWERED", []);
            context.commit("SET_QUESTIONS", []);
            context.commit("SET_QUESTIONS_AND_ANSWERS", []);
            context.commit("SET_INFORMATION", {});
            context.commit("SET_ID_INSTITUTION", null);
            context.commit("NOT_FOUND", true);
        }
    },
    getters: {
        getQuestions(state: IQuiz) {
            return state.questions;
        },
        getQuestionsAnswered(state: IQuiz) {
            return state.questionsAnswered;
        },
        getQuestionsAndAnswers(state: IQuiz) {
            return state.questionAndAnswers;
        },
        getquantityQuestions(state: IQuiz) {
            return state.quantityQuestions;
        },
        getCategories(state: IQuiz) {
            return state.categories;
        },
        getQuiz(state: IQuiz) {
            return state.quiz;
        },
        getInformation(state: IQuiz) {
            return state.information;
        },
        // getAnsweredSurveys(state: IQuiz) {
        //     return state.answeredSurveys;
        // },
        // getNotFound(state: IQuiz) {
        //     return state.notFound;
        // }
    }
};
